@if(showHeader){
<div class="header-bar" [class.input-open]="inputOpen()" [style.visibility]="viewActive() ? 'hidden' : null">
  <app-header></app-header>
  <hc-sync-indicator></hc-sync-indicator>
  <hc-mesh-header [meshPublic]="meshPublic()" (meshToggled)="toggleMesh()"></hc-mesh-header>
</div>
}
<router-outlet></router-outlet>
<!-- Pixi canvas hosts the hexagon surface. Hidden when ViewMode != 'hexagons'
     so other rendering surfaces (website, future modes) take over without
     fighting it for input. The Pixi runtime keeps running so a toggle
     back is instant — no rebuild of textures / atlases. -->
<div id="pixi-host" [style.display]="viewMode() === 'hexagons' ? 'block' : 'none'" style="z-index: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></div>
<hc-controls-bar [meshPublic]="meshPublic()" (meshToggled)="toggleMesh()" [style.visibility]="viewActive() ? 'hidden' : null"></hc-controls-bar>
<hc-selection-context-menu></hc-selection-context-menu>
<hc-history-viewer></hc-history-viewer>
<hc-notes-strip></hc-notes-strip>
<hc-notes-viewer></hc-notes-viewer>
<hc-tile-editor></hc-tile-editor>
<hc-camera-capture></hc-camera-capture>
<hc-portal-overlay></hc-portal-overlay>
<hc-confirm-dialog></hc-confirm-dialog>
<hc-mesh-modal></hc-mesh-modal>
<hc-trust-prompt></hc-trust-prompt>
<hc-sensitivity-bar></hc-sensitivity-bar>
<hc-docs-overlay></hc-docs-overlay>
<hc-layer-cycle-strip></hc-layer-cycle-strip>
<hc-toast></hc-toast>
<hc-presence-banner></hc-presence-banner>
<hc-swarm-adopt-panel></hc-swarm-adopt-panel>
@if (installNeeded()) {
<div class="install-prompt" role="dialog" aria-modal="true" aria-labelledby="install-title">
  <div class="install-card">
    <h2 id="install-title">Welcome to Hypercomb</h2>
    @if (storageBlocked()) {
      <p class="install-blocked">
        Hypercomb keeps your hive in the browser's persistent storage,
        which isn't available here. If this is a Private window, open a
        regular one. If you're on an older Mac or Safari, update to a
        recent version. Then reload this page.
      </p>
    } @else {
      <button class="install-cta" type="button" (click)="startWelcome()" [disabled]="upgrading()">
        @if (upgrading()) { Starting… } @else { Start }
      </button>
    }
  </div>
</div>
}
